module.exports = __webpack_public_path__ + "static/media/BariolRegular-Italic.b4cf15f3.woff2";